<article *ngIf="data" [style.background-color]="'#' + theme" #brandhero>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6 offset-lg-1">
                <div class="content-wrapper">
                    <div class="content" [ngClass]="{ white: data.textColor === textColor.White }">
                        <div class="logo-wrapper">
                            <app-image
                                *ngIf="data.logo && data.logo.src"
                                [image]="data.logo"
                                [width]="data.logoWidth"
                                [index]="data.spotIndex"
                                crop="min"
                                format="none"
                            ></app-image>
                        </div>
                        <app-spot-headline *ngIf="data.headlineText" [index]="data.spotIndex" section="h1">
                            {{ data.headlineText }}
                        </app-spot-headline>
                        <div
                            *ngIf="data.richText"
                            class="kk-rte text"
                            appInterceptLinks
                            [innerHTML]="data.richText | safe: 'html'"
                        ></div>
                        <app-scroll-link [target]="brandhero" [scrollBy]="true" [offset]="50">
                            {{ data.linkText }}
                        </app-scroll-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-5 image-aligner">
                <div class="image-wrapper" appParallaxElement [travel]="40" [dullness]="10">
                    <app-image
                        *ngIf="data.image && data.image.src"
                        [image]="data.image"
                        [index]="data.spotIndex"
                        [width]="583"
                        [height]="721"
                        crop="min"
                    ></app-image>
                </div>
            </div>
        </div>
    </div>
</article>
